import React from 'react'
import { Box, Link } from '@ally/metronome-ui'

const WidgetFooter: React.FC = (): React.ReactElement => {
  return (
    <Box textAlign="right">
      <Link
        text="More transfer options"
        to="/payments/transfers"
        withAllyTM="TW More Transfer Options"
      />
    </Box>
  )
}

export default WidgetFooter
